/*
 * 文件名: sso.js
 * 描述: 提供对 CAS 单点登录的封装
 * 版本: 1.3.0.1098-20190103
 *
 * 功能说明:
 * 实现多个应用之间的单点登录（SSO）功能,应用可以部署在不同的域名。
 *
 * 兼容性说明:
 * 此版本sdk,同时支持普通项目使用,以及前后端分离项目使用。
 *
 * 接口列表:
 * login,登录接口
 * loginExt,扩展登录接口
 * logout,登出接口
 * getLoginState,获取登录状态接口
 * validateServiceTicket,验证ST接口
 * getDeviceId,获取设备ID接口
 * getAccessToken,获取访问token接口
 *
 * 登录方式:
 * 1.普通登录(account,password)
 * 2.验证码登录(loginType,phoneNum,smsVerifyCode)
 * 3.TGT在线自动登录(account,loginType,mac,tgt,timestamp,username,signature)
 * 4.通用方式登录(loginType,genericValidateUserAttributes,genericUserInfoAttributes)
 * 5.免密登录(loginType,token,platformKey,signature)
 * 6.账号切换(account)
 *
 */
import $ from "jquery";
(function(undefined) {
  var SSO = {
    // 版本号,关联SSO服务端版本号-日期
    _version: "1.4.0.1100-20190115",
    // 用户服务所属用户组
    appName: "edc",
    // 集成应用使用的appKey
    appKey: "default-appkey",
    // 集成端的属性(web,pc,app,pc-web,app-web)
    client: "web",
    // 设备ID
    deviceId: getDeviceId(),
    // Mac地址
    mac: "",
    // Token的Scope范围(openapi/apigateway,空格分隔)
    scope: "openapi apigateway",
    // 当前连接SSO的服务地址
    SSOServerUrl: "http://open.changyan.com/sso",
    // 登录后跳转服务地址(地址中appId参数会被解析)
    loginRedirectUrl: "http://i.changyan.com/icloud",
    // 区域EDC项目需要修改
    SSOCenterServerUrl: "http://open.changyan.com/sso",
    // 当前连接的SSO是否是中心节点
    isCenterSSO: true,
    // tgt同步方式,1表示还是以前的同步方式,2表示使用同步组件来进行同步
    syncType: 1,
    // 是否返回更多用户属性
    needAttribute: true,
    // 是否需要OpenApi、网关使用的token
    needToken: false,
    // 失败重试标记
    _retry: false,
    // 登录方式
    loginType: {
      LOGINBYNORMAL: "loginByNormal",
      LOGINBYVERIFYCODE: "loginByVerifyCode",
      LOGINBYONLINEAUTO: "loginByOnLineAuto",
      LOGINBYGENERIC: "loginByGeneric",
      LOGINBYTOKEN: "loginByToken",
      LOGINBYCHANGEACCOUNT: "loginByChangeAccount",
    },

    login: function(account, password, callback) {
      SSOLogin(account, password, callback);
    },

    loginExt: function(loginObj, callback) {
      SSOLoginExt(loginObj, callback);
    },

    logout: function(callback) {
      SSOLogout(undefined, callback);
    },

    logoutExt: function(param, callback) {
      SSOLogout(param, callback);
    },

    getDeviceId: function(deviceId) {
      return getDeviceId(deviceId);
    },

    getLoginState: function(callback) {
      return getLoginStatus(callback);
    },

    getAccessToken: function(callback) {
      getTokenFromSSO(callback);
    },

    validateServiceTicket: function(st, service, callback) {
      validateServiceTicket(st, service, callback);
    },

    wxLoginFrame: function(param, callback) {
      _wxLoginFrame(param);

      window.addEventListener(
        "message",
        function(e) {
          console.log("Received message:" + JSON.stringify(e.data));
          callback && callback(e.data);
          return;
        },
        false,
      );
    },

    wxLoginUrl: function(param) {
      return _wxLoginUrl(param);
    },

    qqLoginUrl: function() {
      return _qqLoginUrl();
    },

    weiboLoginUrl: function() {
      return _weiboLoginUrl();
    },
  };

  window.SSO = window.SSO || SSO;

  function getToken(resultObj, callback) {
    var response = {};
    // 尝试获取token
    var args = {};
    args.appKey = SSO.appKey;
    args.tgt = resultObj.data.tgt;
    args.st = resultObj.data.st;
    args.service = SSO.loginRedirectUrl;
    args.client = SSO.client;
    args.mac = SSO.mac;
    args.scope = SSO.scope;
    var deviceId = SSO.deviceId;
    args.extInfo = '{"deviceId": "' + deviceId + '"}';

    var SSOValidateUrl = SSO.SSOServerUrl + "/v1/validationWeb";
    if (
      SSO.client === "pc" ||
      SSO.client === "app" ||
      SSO.client === "pc-web" ||
      SSO.client === "app-web"
    ) {
      SSOValidateUrl = SSO.SSOServerUrl + "/v1/validationV2";
    }

    //访问SSO服务地址,获取token
    $.ajax({
      url: SSOValidateUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      data: args,
      success: function(resultObj) {
        if (
          resultObj &&
          resultObj.code === "1" &&
          resultObj.data &&
          resultObj.data.token
        ) {
          response.result = "success";
          response.code = resultObj.code;
          response.data = {
            token: resultObj.data.token,
            tgt: args.tgt,
            loginName: resultObj.data.loginName,
            userId: resultObj.data.userId,
          };
          response.message = resultObj.message;
        } else {
          response.result = "fail";
          response.code = resultObj.code;
          response.message = resultObj.message;
        }
        callback && callback(response);
      },
      error: function(resultObj) {
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        response.data = { tgt: args.tgt };
        callback && callback(response);
      },
    });
  }

  function getTokenFromSSO(callback) {
    analyseServiceURL(
      SSO.needAttribute,
      SSO.appKey,
      SSO.client,
      SSO.loginRedirectUrl,
    );
    //获取当前用户登录状态
    getLoginStatus(function(resultObj) {
      if (resultObj && resultObj.result === "success") {
        getToken(resultObj, callback);
      } else {
        callback && callback(resultObj);
      }
    });
  }

  function getLoginStatus(callback) {
    var response = {};
    //访问SSO服务地址,获取当前SSO登录状态
    $.ajax({
      url:
        SSO.SSOServerUrl +
        "/login?service=" +
        encodeURIComponent(SSO.loginRedirectUrl),
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      success: function(html) {
        html = $.trim(html).replace(/\t/g, "");
        var resultObj = evalJSON(html);
        if (resultObj.result && resultObj.result === "success") {
          //已经登录了
          if (
            parseInt(resultObj.code) === 1001 &&
            resultObj.data &&
            resultObj.data.st
          ) {
            response.result = "success";
            response.code = resultObj.code;
            response.message = resultObj.message;
            response.data = {
              tgt: resultObj.data.tgt,
              st: resultObj.data.st,
            };
            callback && callback(response);
            return;
          }
        }
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        callback && callback(response);
      },
      error: function(resultObj) {
        response.result = "fail";
        response.code = resultObj.code;
        response.message = resultObj.message;
        callback && callback(response);
      },
    });
  }

  function analyseServiceURL() {
    var currentUrl = window.location.href;
    if (Url.queryString("nextpage", currentUrl) === undefined) {
      SSO.loginRedirectUrl =
        SSO.needAttribute &&
        Url.queryString("from", SSO.loginRedirectUrl) === undefined
          ? Url.addParams({ from: "ew" }, SSO.loginRedirectUrl)
          : SSO.loginRedirectUrl;
    } else {
      var nextpageUrl = Url.queryString("nextpage", currentUrl);
      SSO.loginRedirectUrl = Base64.decode(nextpageUrl);
    }
    if (Url.queryString("client", currentUrl) !== undefined) {
      SSO.client = Url.queryString("client", currentUrl);
    }
    if (Url.queryString("appId", SSO.loginRedirectUrl) !== undefined) {
      SSO.appKey = Url.queryString("appId", SSO.loginRedirectUrl);
    }
  }

  function getLoginTicket(loginType, callback) {
    var redirectUrl =
      loginType === SSO.loginType.LOGINBYCHANGEACCOUNT
        ? Url.addParams({ userChangeLogin: true }, SSO.loginRedirectUrl)
        : SSO.loginRedirectUrl;
    if (SSO.isCenterSSO === false) {
      var SSOCenterRestUrl =
        SSO.SSOCenterServerUrl +
        "/login?service=" +
        encodeURIComponent(redirectUrl);
      $.ajax({
        url: SSOCenterRestUrl,
        type: "GET",
        dataType: "jsonp",
        jsonp: "callback",
        crossDomain: true,
        cache: false,
        success: function(html) {
          html = $.trim(html).replace(/\t/g, "");
          var resultObj = evalJSON(html);
          if (resultObj.result && resultObj.result === "success") {
            //已经登录了
            if (
              parseInt(resultObj.code) === 1001 &&
              resultObj.data &&
              resultObj.data.st
            ) {
              if (
                loginType !== SSO.loginType.LOGINBYONLINEAUTO &&
                loginType !== SSO.loginType.LOGINBYCHANGEACCOUNT
              ) {
                CenterSSOLogout();
              }
              //新增用户切换登录
              else if (loginType === SSO.loginType.LOGINBYCHANGEACCOUNT) {
                var params = {
                  lt: resultObj.data.lt,
                  execution: resultObj.data.execution,
                };
                callback && callback(params);
              }
              callback && callback(resultObj);
              return;
            }
          }
        },
        error: function(data) {
          console.log(data);
        },
      });
    }
    var SSORestUrl =
      SSO.SSOServerUrl + "/login?service=" + encodeURIComponent(redirectUrl);
    $.ajax({
      url: SSORestUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      success: function(html) {
        html = $.trim(html).replace(/\t/g, "");
        var resultObj = evalJSON(html);
        if (resultObj.result && resultObj.result === "success") {
          //已经登录了
          if (
            parseInt(resultObj.code) === 1001 &&
            resultObj.data &&
            resultObj.data.st
          ) {
            if (
              loginType !== SSO.loginType.LOGINBYONLINEAUTO &&
              loginType !== SSO.loginType.LOGINBYCHANGEACCOUNT
            ) {
              SSOLogout(function() {
                setTimeout(function() {
                  getLoginTicket(loginType, callback);
                }, 100);
                return;
              });
            }
            //新增用户切换登录
            if (loginType === SSO.loginType.LOGINBYCHANGEACCOUNT) {
              var params = {
                lt: resultObj.data.lt,
                execution: resultObj.data.execution,
              };
              callback && callback(params);
            }
            callback && callback(resultObj);
            return;
          } else {
            var params = {
              lt: resultObj.data.lt,
              execution: resultObj.data.execution,
            };
            callback && callback(params);
          }
        } else {
          callback && callback(undefined);
        }
      },
      error: function(data) {
        callback && callback(undefined);
      },
    });
  }

  function SSOLogin(account, password, callback) {
    var loginParam = {};
    loginParam.account = account;
    loginParam.password = password;
    SSOLoginExt(loginParam, callback);
  }

  function SSOLoginExt(loginObj, callback) {
    analyseServiceURL(
      SSO.needAttribute,
      SSO.appKey,
      SSO.client,
      SSO.loginRedirectUrl,
    );
    var loginType = loginObj.loginType || SSO.loginType.LOGINBYNORMAL;
    getLoginTicket(loginType, function(ltParams) {
      if (
        ltParams === undefined &&
        loginType !== SSO.loginType.LOGINBYCHANGEACCOUNT
      ) {
        var resultObj = {
          result: "fail",
          code: "-1",
          data: "登录失败,出现异常！",
        };
        callback && callback(resultObj);
      } else {
        loginObj = loginObj || {};
        var pl = {};
        pl.encode = true;
        pl.sourceappname = SSO.appName;
        pl._eventId = "submit";
        pl.appId = SSO.appKey;
        pl.client = loginObj.client || SSO.client;
        pl.type = loginObj.loginType || SSO.loginType.LOGINBYNORMAL;
        pl.key =
          loginObj.key || getAccountType(loginObj.account, SSO.isCenterSSO);
        pl.lt = ltParams.lt;
        pl.execution = ltParams.execution;
        // 扩展信息字段
        if (loginObj.extInfo != null && loginObj.extInfo !== "") {
          pl.extInfo = loginObj.extInfo;
        } else if (
          SSO.client === "pc" ||
          SSO.client === "app" ||
          SSO.client === "pc-web" ||
          SSO.client === "app-web"
        ) {
          var deviceId = SSO.deviceId;
          pl.extInfo = '{"deviceId": "' + deviceId + '"}';
        }
        // 在线自动登录
        if (loginType === SSO.loginType.LOGINBYONLINEAUTO) {
          pl.username = loginObj.account;
          pl.mac = loginObj.mac || SSO.mac;
          pl.tgt = loginObj.tgt;
          pl.timestamp = loginObj.timestamp;
          pl.signature = loginObj.signature;
        }
        // 手机验证码登录
        else if (loginType === SSO.loginType.LOGINBYVERIFYCODE) {
          pl.phoneNum = loginObj.phoneNum;
          pl.smsVerifyCode = loginObj.smsVerifyCode;
        }
        // 通用登录
        else if (loginType === SSO.loginType.LOGINBYGENERIC) {
          pl.genericValidateUserAttributes =
            loginObj.genericValidateUserAttributes;
          pl.genericUserInfoAttributes = loginObj.genericUserInfoAttributes;
        }
        // 免密令牌登录
        else if (loginType === SSO.loginType.LOGINBYTOKEN) {
          pl.token = loginObj.token;
          pl.platformKey = loginObj.platformKey;
          pl.signature = loginObj.signature;
          pl.mac = loginObj.mac || SSO.mac;
        }
        //多账号免密切换登录
        else if (loginType === SSO.loginType.LOGINBYCHANGEACCOUNT) {
          pl.username = loginObj.account;
        }
        // 普通登录
        else {
          pl.username = loginObj.account;
          var exponent = "010001";
          var modulus = "008c147f73c2593cba0bd007e60a89ade5";
          var key = RSAUtils.getKeyPair(exponent, "", modulus);
          pl.password = RSAUtils.encryptedString(key, loginObj.password);
          if (
            (loginObj.mac != null && loginObj.mac !== "") ||
            (SSO.mac != null && SSO.mac !== "")
          ) {
            pl.mac = loginObj.mac || SSO.mac;
          }
        }
        var redirectUrl =
          loginType === SSO.loginType.LOGINBYCHANGEACCOUNT
            ? Url.addParams({ userChangeLogin: true }, SSO.loginRedirectUrl)
            : SSO.loginRedirectUrl;
        var SSORestUrl =
          SSO.SSOServerUrl +
          "/login?service=" +
          encodeURIComponent(redirectUrl);
        $.ajax({
          url: SSORestUrl,
          type: "GET",
          dataType: "jsonp",
          jsonp: "callback",
          data: pl,
          crossDomain: true,
          cache: false,
          success: function(html) {
            html = $.trim(html).replace(/\t/g, "");
            var resultObj = evalJSON(html);
            if (resultObj.result && resultObj.result === "success") {
              if (parseInt(resultObj.code) === 1000) {
                if (SSO._retry === false) {
                  //try again
                  SSO._retry = true;
                  SSOLoginExt(loginObj, callback);
                  return;
                }
                callback && callback(resultObj);
                return;
              }
              SSO._retry = false;
              resultObj.params = pl;
              if (SSO.needToken) {
                // 获取Token
                getToken(resultObj, function(resultObj) {
                  syncToCenter(resultObj, callback);
                });
              } else {
                syncToCenter(resultObj, callback);
              }
            } else {
              callback && callback(resultObj);
              return;
            }
          },
          error: function(data) {
            SSO._retry = false;
            var resultObj = {
              result: "fail",
              code: "-1",
              data: "登录失败,出现异常！",
            };
            callback && callback(resultObj);
          },
        });
      }
    });
  }

  function syncToCenter(resultObj, callback) {
    // sync TGT to centerSSO, only to ensure TGC added to center sso path
    if (SSO.isCenterSSO === false && SSO.syncType === 1) {
      syncToCenterSSO(resultObj.data.tgt, function() {
        callback && callback(resultObj);
      });
    } else if (SSO.isCenterSSO === false && SSO.syncType === 2) {
      syncToCenterSSO2(function() {
        callback && callback(resultObj);
      });
    } else {
      callback && callback(resultObj);
    }
  }

  function syncToCenterSSO(TGT, callback) {
    var SSORestUrl =
      SSO.SSOCenterServerUrl +
      "/login?ticketGrantingTicketIdFromAreaSSO=" +
      TGT;
    $.ajax({
      url: SSORestUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      success: function(resultObj) {
        resultObj = evalJSON(resultObj);
        callback && callback(resultObj);
      },
      error: function(resultObj) {
        resultObj = evalJSON(resultObj);
        callback && callback(resultObj);
      },
    });
  }

  /**
   *  同步tgt到中心
   **/
  function syncToCenterSSO2(callback) {
    var syncUrl =
      SSO.SSOServerUrl +
      "/login?service=" +
      encodeURIComponent(
        Url.addParams({ isAjax: "true" }, SSO.loginRedirectUrl),
      ) +
      "&redirect=true";
    jQuery.ajax({
      url: syncUrl,
      type: "get",
      dataType: "jsonp",
      jsonp: "callback",
      xhrFields: {
        withCredentials: true,
      },
      crossDomain: true,
      success: function(resultObj) {
        resultObj = evalJSON(resultObj);
        callback && callback(resultObj);
      },
      error: function(resultObj) {
        resultObj = evalJSON(resultObj);
        callback && callback(resultObj);
      },
    });
  }

  function validateServiceTicket(st, service, callback) {
    if (st === undefined || service === undefined) {
      var resultObj = { result: "fail", code: "-1", data: "参数不合法" };
      callback && callback(resultObj);
      return;
    }
    var SSOValidateUrl = SSO.SSOServerUrl + "/v1/validation";
    var pl = {};
    pl.service = service;
    pl.ticket = st;
    $.ajax({
      url: SSOValidateUrl,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      data: pl,
      crossDomain: true,
      cache: false,
      success: function(json) {
        callback && callback(json);
      },
      error: function(data) {
        var resultObj = {
          result: "fail",
          code: "-1",
          data: "校验失败,出现异常！",
        };
        callback && callback(resultObj);
      },
    });
  }

  function SSOLogout(param, callback) {
    var logoutURL = SSO.SSOServerUrl + "/logout";
    if (typeof param === "object") {
      logoutURL = param.tgtId
        ? Url.addParams({ tgtId: param.tgtId }, logoutURL)
        : logoutURL;
      logoutURL = param.clearScope
        ? Url.addParams({ clearScope: param.clearScope }, logoutURL)
        : logoutURL;
    }
    $.ajax({
      url: logoutURL,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      success: function(html) {
        html = $.trim(html).replace(/\t/g, "");
        var resultObj = evalJSON(html);
        if (resultObj.result && resultObj.result === "success") {
          callback && callback(resultObj);
        }
      },
      error: function(data) {
        var resultObj = {
          result: "fail",
          code: "-1",
          data: "登出失败,出现异常！",
        };
        callback && callback(resultObj);
      },
    });
  }

  function CenterSSOLogout() {
    var logoutURL = SSO.SSOCenterServerUrl + "/logout";
    $.ajax({
      url: logoutURL,
      type: "GET",
      dataType: "jsonp",
      jsonp: "callback",
      crossDomain: true,
      cache: false,
      success: function(data) {
        console.log(data);
      },
      error: function(data) {
        console.log(data);
      },
    });
  }

  function getAccountType(account, isCenterSSO) {
    var REGEX_EMAIL = new RegExp(
      "^[0-9a-z]([._]?[0-9a-z])+@([0-9a-z][-\\w]*[0-9a-z]\\.)+[a-z]{2,9}$",
    );
    var REGEX_MOBILE = new RegExp("^1[3-9]\\d{9}$");
    var REGEX_EXAM_NO = new RegExp("^\\d{8}$"); //准考证号8位数字
    var REGEX_STUDENT_EXAM_NO = new RegExp("^\\d{16}$"); //学籍号16位数字
    var type = "login_name";
    if (account === undefined) {
      return type;
    } else if (account.match(REGEX_EMAIL)) {
      type = isCenterSSO === true ? "login_email" : "email";
    } else if (account.match(REGEX_MOBILE)) {
      type = isCenterSSO === true ? "login_mobile" : "mobile";
    } else if (account.match(REGEX_EXAM_NO)) {
      type = "exam_no";
    } else if (account.match(REGEX_STUDENT_EXAM_NO)) {
      type = "student_enroll_no";
    }
    return type;
  }

  function getDeviceId(deviceId) {
    // 主动设置deviceId
    if (!!deviceId) {
      setCookie("deviceId", deviceId, 365);
    }
    // 获取deviceId
    deviceId = getCookie("deviceId");
    if (!deviceId) {
      deviceId = Math.uuid();
      setCookie("deviceId", deviceId, 365);
    }
    return deviceId;
  }

  function evalJSON(s) {
    return eval("(" + s + ")");
  }

  function _wxLoginFrame(param) {
    var url = _wxLoginUrl(param);
    var iframe = document.createElement("iframe");
    iframe.src = url;
    iframe.frameBorder = param.frameBorder || "0";
    iframe.allowTransparency = param.allowTransparency || "true";
    iframe.scrolling = param.scrolling || "no";
    iframe.width = param.width || "300px";
    iframe.height = param.height || "400px";
    var frameContainer = document.getElementById(param.id);
    frameContainer.innerHTML = "";
    frameContainer.appendChild(iframe);
  }

  function _wxLoginUrl(param) {
    var url = SSO.SSOServerUrl + "/login?thirdLoginType=wechatLogin";
    url += "&client=" + SSO.client;
    url += "&mac=" + SSO.mac;
    url +=
      "&extInfo=" + encodeURIComponent('{"deviceId": "' + SSO.deviceId + '"}');
    if (typeof param === "object") {
      var c = "default";
      param.self_redirect === !0
        ? (c = "true")
        : param.self_redirect === !1 && (c = "false");
      url += "&login_type=jssdk&self_redirect=" + c;
      url += param.service
        ? "&service=" + encodeURIComponent(param.service)
        : "";
      url +=
        param.customConfig && typeof param.customConfig === "object"
          ? "&customConfig=" + Base64.encode(JSON.stringify(param.customConfig))
          : "";
      url += param.style ? "&style=" + param.style : "";
      url += param.href ? "&href=" + encodeURIComponent(param.href) : "";
      url += param.xscheme ? "&xscheme=" + param.xscheme : "";
    }
    return url;
  }

  function _qqLoginUrl(param) {
    var url = SSO.SSOServerUrl + "/login?thirdLoginType=qqLogin";
    url += "&client=" + SSO.client;
    url += "&mac=" + SSO.mac;
    url +=
      "&extInfo=" + encodeURIComponent('{"deviceId": "' + SSO.deviceId + '"}');
    if (typeof param === "object") {
      url += param.service
        ? "&service=" + encodeURIComponent(param.service)
        : "";
      url +=
        param.customConfig && typeof param.customConfig === "object"
          ? "&customConfig=" + Base64.encode(param.customConfig)
          : "";
    }
    return url;
  }

  function _weiboLoginUrl(param) {
    var url = SSO.SSOServerUrl + "/login?thirdLoginType=weiboLogin";
    url += "&client=" + SSO.client;
    url += "&mac=" + SSO.mac;
    url +=
      "&extInfo=" + encodeURIComponent('{"deviceId": "' + SSO.deviceId + '"}');
    if (typeof param === "object") {
      url += param.service
        ? "&service=" + encodeURIComponent(param.service)
        : "";
      url +=
        param.customConfig && typeof param.customConfig === "object"
          ? "&customConfig=" + Base64.encode(param.customConfig)
          : "";
    }
    return url;
  }

  function setCookie(name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie =
      name +
      "=" +
      escape(value) +
      (expiredays == null ? "" : ";path=/;expires=" + exdate.toGMTString());
  }

  function getCookie(name, base64) {
    var arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (document.cookie.match(reg)) {
      arr = document.cookie.match(reg);
      if (base64 === true) return Base64.decode(unescape(arr[2]));
      else return unescape(arr[2]);
    } else return null;
  }

  function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  }
})();



// WEBPACK FOOTER //
// ./src/common/js/sso/sso.js